import { Stack } from "@mui/material";
import EmptyList from "components/EmptyList";
import withDragDropContext from "hocs/withDragDropContext";
import { useEffect, useRef, useState } from "react";
import CompetenciesList from "../../components/CompetenciesList";
import { ConstructorTabProps } from "./types";

const CompetenciesListWithDragDropContext = withDragDropContext(CompetenciesList);

interface LeftColumnProps extends Pick<ConstructorTabProps, "fieldArray" | "form" | "isEditable"> {}

const LeftColumn = ({ fieldArray, form, isEditable }: LeftColumnProps) => {
  const blockContainerRef = useRef<HTMLDivElement>(null);
  const [scrollHeight, setScrollHeight] = useState<number>(0);

  const { fields, move, remove } = fieldArray;

  useEffect(() => {
    if (blockContainerRef.current) {
      // TODO происходит скролл при ините, тк есть состояние между загрузкой и заполнением filds
      const currentScrollHeight = blockContainerRef.current.scrollHeight;
      if (currentScrollHeight > scrollHeight && scrollHeight !== 0) {
        blockContainerRef.current.scrollTo({
          top: blockContainerRef.current.scrollHeight,
          behavior: "smooth",
        });
      }
      setScrollHeight(blockContainerRef.current.scrollHeight);
    }
  }, [fields.length]);

  return (
    <Stack
      direction='column'
      spacing={2.5}
      ref={blockContainerRef}>
      {!fields.length && !isEditable ? (
        <EmptyList emptyPlaceholderText='Пока нет компетенций' />
      ) : (
        <CompetenciesListWithDragDropContext
          droppableId='competenciesList'
          moveItems={move}
          fields={fields}
          form={form}
          remove={remove}
          isEditable={isEditable}
        />
      )}
    </Stack>
  );
};

export default LeftColumn;
